<template>
  <div class="tab_container">
    <!-- 主要竞争对手 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        主要竞争对手
        <el-button
          v-if="$route.query.operateType !== '查看'"
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('mainCompetitor')"
          >保存</el-button
        >
      </div>
    </div>
    <main-competitor ref="mainCompetitor" />
    <!-- 主要竞品 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        主要竞品
      </div>
    </div>
    <!-- 我司车型/竞品对应关系 -->
    <div class="second_title">
      我司车型/竞品对应关系
      <el-button
        v-if="$route.query.operateType !== '查看'"
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('competeProductSale')"
        >保存</el-button
      >
    </div>
    <compete-product-sale ref="competeProductSale" />
    <!-- 我司车型/竞品产品价格 -->
    <div class="second_title">
      我司车型/竞品产品价格
      <el-button
        v-if="$route.query.operateType !== '查看'"
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('competeProductPrice')"
        >保存</el-button
      >
    </div>
    <compete-product-price ref="competeProductPrice" />
  </div>
</template>

<script>
import MainCompetitor from "./mainCompetitor.vue";
import CompeteProductSale from "./competeProductSale.vue";
import CompeteProductPrice from "./competeProductPrice.vue";
import { getCompeteInfoApi } from "@/api/saleTaskCollection";

export default {
  components: {
    MainCompetitor,
    CompeteProductSale,
    CompeteProductPrice
  },
  data() {
    return {};
  },
  created() {
    this.getCompeteInfo();
  },
  methods: {
    // 获取历史销量导入
    async getCompeteInfo() {
      try {
        let data = {};
        if (this.$route.query.areaName && this.$route.query.countryName) {
          const res = await getCompeteInfoApi({
            areaName: this.$route.query.areaName,
            countryName: this.$route.query.countryName
          });
          if (res.status == 0) {
            data = res.data || {};
          } else {
            this.$DonMessage.error(res.message);
          }
        }
        this.$refs.mainCompetitor.init(data.saleCompetitionOpponentList);
        this.$refs.competeProductSale.init(
          data.saleCompetitionProductsShixiaoList
        );
        this.$refs.competeProductPrice.init(
          data.saleCompetitionProductsPriceList
        );
      } catch (error) {}
    },
    // 保存
    handleSave(refField) {
      let submitData = {};
      if (refField !== "baseInfo") {
        if (!this.$route.query.baseInfoId) {
          this.$DonMessage.warning("请先保存基础信息")
          return;
        }
        submitData = {
          areaName: this.$route.query.areaName,
          countryName: this.$route.query.countryName
        };
      }
      this.$refs[refField].handleSave(submitData);
    }
  }
};
</script>

<style lang="scss" scoped>
.tab_container {
  padding-bottom: 20px;
  .hearder_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title_icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .second_title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .title_btn {
    margin-left: 20px;
  }
}
</style>
